module.exports = __webpack_public_path__ + "img/6417001.png";